import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_CON024_Request,
  IAPI_CON024_Response,
  IAPI_CON029_Request,
  IAPI_CON029_Response,
} from "../../../type/apiType";

// 契約者申請情報参照
// API仕様書_契約者（新規契約～施設追加～職員追加）
const httpAPI_CON024 = async (
  param: IAPI_CON024_Request
): Promise<IAPI_CON024_Response> => {
  let res = await http.post(ApiUrl.API_CON024, {
    ...param,
  });

  return res.data;
};

// 契約者申請情報更新
// API仕様書_契約者（新規契約～施設追加～職員追加）
const httpAPI_CON029 = async (
  param: IAPI_CON029_Request
): Promise<IAPI_CON029_Response> => {
  let res = await http.post(ApiUrl.API_CON029, {
    ...param,
  });

  return res.data;
};

export { httpAPI_CON024, httpAPI_CON029 };
